import { createStore } from 'vuex'

export default createStore({
  state: {
    currencySign: '₽',
    acquiring: 35,
    tipsServiceCommission: 0.077,
    loyaltyType: null,
    loyaltySum: 0,
    user: null,
    items: [],
    catalogGoods: [],
    userInfo: null,
    url: '',
    names: '',
    customer: {
      firstName: '',
      lastName: '',
      phone: '',
      email: ''
    },
    colorSchemeName: '',
    domain: ''
  },
  mutations: {
    SET_DOMAIN(state, domain) {
      state.domain = domain
    },
    SET_USER(state, user) {
      state.user = user
    },
    SET_COLOR_SCHEME_NAME(state, colorSchemeName) {
      state.colorSchemeName = colorSchemeName
    },
    SET_ITEMS(state, items) {
      state.items = items
    },
    SET_CATALOG_GOODS(state, catalogGoods) {
      state.catalogGoods = catalogGoods
    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo
    },
    SET_USER_URL(state, url) {
      state.url = url
    },
    SET_USER_NAMES(state, names) {
      state.names = names
    },
    SET_CUSTOMER(state, customer) {
      state.customer = customer
    },
    SET_LOYALTY_TYPE(state, loyaltyType) {
      state.loyaltyType = loyaltyType
    },
    SET_LOYALTY_SUM(state, loyaltySum) {
      state.loyaltySum = loyaltySum
    },
    SET_CURRENCY_SIGN(state, currencySign) {
      state.currencySign = currencySign
    }
  },

  actions: {
    setDomain({ commit }, domain) {
      commit('SET_DOMAIN', domain)
    },
    setCustomer({ commit }, customer) {
      commit('SET_CUSTOMER', customer)
    },
    setUser({ commit }, user) {
      commit('SET_USER', user)
    },
    setItems({ commit }, items) {
      commit('SET_ITEMS', items)
    },
    setCatalogGoods({ commit }, catalogGoods) {
      commit('SET_CATALOG_GOODS', catalogGoods)
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo)
    },
    setUserUrl({ commit }, url) {
      commit('SET_USER_URL', url)
    },
    setUserNames({ commit }, names) {
      commit('SET_USER_NAMES', names)
    },
    setLoyaltyType({ commit }, loyaltyType) {
      commit('SET_LOYALTY_TYPE', loyaltyType)
    },
    setLoyaltySum({ commit }, loyaltySum) {
      commit('SET_LOYALTY_SUM', loyaltySum)
    },
    setCurrencySign({ commit }, currencySign) {
      commit('SET_CURRENCY_SIGN', currencySign)
    },
    SET_COLOR_SCHEME_NAME({ commit }, colorSchemeName) {
      commit('SET_COLOR_SCHEME_NAME', colorSchemeName)
    }
  },
  getters: {
    GET_USERS_URLS(state) {
      const userInfoArr = state.userInfo as Array<{ urlAvatar: string; id: string }> | null
      if (!Array.isArray(userInfoArr)) return []
      return userInfoArr.map(({ urlAvatar, id }) => {
        return { id, urlAvatar }
      })
    },
    GET_DOMAIN(state) {
      return state.domain
    },
    GET_USER(state) {
      return state.user
    },
    GET_ITEMS(state) {
      return state.items
    },
    GET_CATALOG_GOODS(state) {
      return state.catalogGoods
    },
    GET_USER_INFO(state) {
      return state.userInfo
    },
    GET_USER_URL(state) {
      return state.url
    },
    GET_USER_NAMES(state) {
      return state.names
    },
    GET_CUSTOMER(state) {
      return state.customer
    },
    GET_CURRENCY_SIGN(state) {
      return state.currencySign
    },
    GET_ACQUIRING(state) {
      return state.acquiring
    },
    GET_TIPS_SERVICE_COMMISSION(state) {
      return state.tipsServiceCommission
    },
    GET_LOYALTY_TYPE(state) {
      return state.loyaltyType
    },
    GET_LOYALTY_SUM(state) {
      return state.loyaltySum
    },
    GET_COLOR_SCHEME_NAME(state) {
      return state.colorSchemeName
    }
  }
})
